import { render } from "./patient-medical-record.vue?vue&type=template&id=3d21096c"
import script from "./patient-medical-record.vue?vue&type=script&lang=js"
export * from "./patient-medical-record.vue?vue&type=script&lang=js"

import "./patient-medical-record.vue?vue&type=style&index=0&id=3d21096c&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__